import createStore from "@/utils/create-store";
import Model from "@/models/admin/honours";

export default createStore({ Model });
